import { render } from "./TheGlobalNav.vue?vue&type=template&id=4e51d90a&scoped=true&ts=true"
import script from "./TheGlobalNav.vue?vue&type=script&lang=ts"
export * from "./TheGlobalNav.vue?vue&type=script&lang=ts"

import "./TheGlobalNav.vue?vue&type=style&index=0&id=4e51d90a&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e51d90a"]])

export default __exports__